<template>
  <div :data-test="dataTest" class="raft-radio">
    <template v-for="option in options">
      <input
        v-if="disabled"
        disabled
        type="radio"
        :name="name"
        :key="'' + name + option.value + '-input'"
        :checked="selected === option.value || value === option.value"
        :data-test="'pill-' + option.value"
        :value="option.value"
        :id="'' + name + '-' + (option.id || option.text)"
        :class="small ? 'small' : ''"
      />
      <input
        v-else
        type="radio"
        :name="name"
        :key="'' + name + option.value + '-input'"
        :checked="selected === option.value || value === option.value"
        :data-test="'pill-' + option.value"
        :value="option.value"
        :id="'' + name + '-' + (option.id || option.text)"
        @change="handleRadio"
        :class="small ? 'small' : ''"
      />
      <label
        class="custom-control-label"
        :for="'' + name + '-' + (option.id || option.text)"
        :key="'' + name + option.value + '-label'"
        :class="small ? 'small' : ''"
      >
        {{ option.text || "missing text" }}
      </label>
    </template>
  </div>
</template>

<script>
export default {
  name: "VRadioToggle",
  props: {
    dataTest: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: [String, Boolean],
      default: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleRadio(event) {
      this.$emit("change", event.target.value);
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style scoped>
:root {
  --background-color: var(--cobalt-gray-10, rgb(229, 234, 255));
  --border-color: var(--cobalt-gray-5, rgb(143, 146, 161));
}

* {
  box-sizing: border-box;
}

.raft-radio {
  background: #eae9f4;
  border: 0.0625rem solid #c7c6d5;
  border-radius: 0.5rem;
  width: max-content;
  padding: 0.25rem;
}

.raft-radio input[type="radio"] {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
}

.raft-radio > label {
  display: inline-block;
  cursor: pointer;
  min-width: 3.75rem;
  margin: 0;
  padding: 0 1.25rem;
  color: rgba(0, 0, 0, 0.8);
  font-size: 1rem;
  text-align: center;
  line-height: 2.25rem;
  transition: 0.1s;
  border: 0.0625rem solid transparent;
  height: 2.25rem;
}

label.small {
  min-width: 3rem;
  padding: 0 0.25rem;
  color: rgba(0, 0, 0, 0.8);
  font-size: var(--font-size-50);
  text-align: center;
  line-height: 1.5rem;
  height: 1.5rem;
}

.raft-radio label:first-of-type {
  border-radius: 0.5rem;
}

.raft-radio label:last-of-type {
  border-radius: 0.5rem;
}

.raft-radio input[type="radio"]:hover + label {
  background-color: #ffffff;
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
}

.raft-radio input[type="radio"]:checked + label {
  background: #ffffff;
  border: 0.0625rem solid #9291a4;
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  font-weight: 600;
}

.raft-radio input[type="radio"]:disabled:hover + label {
  background-color: #ffffff;
  box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
}
</style>
